<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    if (!window.localStorage.getItem("openid")) {
      if (
        this.$CommonFun.getUrlKey("code") == null ||
        this.$CommonFun.getUrlKey("code") == ""
      ) {
        //获取code
        window.location.href = this.$Api.getCode();
        return;
      }
      //获取openid,sessionStorage保存openid
      var code = this.$CommonFun.getUrlKey("code");
      this.$Api.getOpenid(code).then(res => {
        window.localStorage.setItem("openid", res.data);
      });
    }
  },
  methods: {}
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 30px; */
}

.mint-indicator-wrapper {
  z-index: 100000000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue